import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Table and Button from Ant Design

function AutoGarageDetails({ allData }) {
  console.log(allData);
  const [data, setData] = useState([]);
  // const [servicesLimit, setServicesLimit] = useState(3);
  // const [livePdLimit, setLivePdLimit] = useState(3);

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the services table
  const servicesColumns = [
    {
      title: "Service Name",
      dataIndex: "service",
    },
    {
      title: "Cost",
      dataIndex: "amount",
    },
    {
      title: "Order Quantity",
      dataIndex: "orderQuantity",
    },
    {
      title: "Order Quantity Per Day",
      dataIndex: "orderQuantityPerDay",
    },
    {
      title: "TAT",
      dataIndex: "tat",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
    },
    {
      title: "Created At",
      dataIndex: "created",
    },
  ];

  // Define columns for the livePD table
  const livePdColumns = [
    {
      title: "Quantity",
      dataIndex: "quantity",
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
    },
    {
      title: "Visit Date",
      dataIndex: "visitDate",
    },
  ];

  // const handleViewAllServices = () => {
  //   setServicesLimit(servicesLimit === 3 ? Infinity : 3);
  // };

  // const handleViewAllLivePd = () => {
  //   setLivePdLimit(livePdLimit === 3 ? Infinity : 3);
  // };

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <div key={index} className="col-12 mb-4">
              <div className="card">
                <div className="card-body"> 
                  <h5 className="text-danger">Services</h5>
                  {/* Services Section */}  
                  {item.services && item.services.length > 0 ? (
                    <div className="table-responsive mb-4">
                      <Table
                        dataSource={item.services}
                        columns={servicesColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.services.length > 3 && (
                        <Button onClick={handleViewAllServices} block>
                          {servicesLimit === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border rounded p-4 mb-2">
                      <p>No services available</p>
                    </div>
                  )}

                  {/* LivePd Section */}
                  <h5 className="text-danger">Live PD</h5>
                  {item.livePd && item.livePd.length > 0 ? (
                    <div className="table-responsive">
                      <Table
                        dataSource={item.livePd}
                        columns={livePdColumns}
                        pagination={false}
                        rowKey={(record) => record.id}
                      />
                      {/* {item.livePd.length > 3 && (
                        <Button onClick={handleViewAllLivePd} block>
                          {livePdLimit === 3 ? "View All" : "Show Less"}
                        </Button>
                      )} */}
                    </div>
                  ) : (
                    <div className="border p-4 mb-2">
                      <p>No live details available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 mb-4">
            <div className="card text-center">
              <div className="card-body">
                <p>No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AutoGarageDetails;
